import Seo, { JsonLd } from '../components/Seo';
import { SITE, CONTACT } from '../config/site';
import { allFaqs } from '../data/faqData';
import { ALL_PLANS } from '../data/pricingData';

import Home from './home';
import Sports from './sports';
import Pricing from './pricing';
import How from './how';
import Trust from './trust';
import Devices from './devices';
import FAQ from './faq';
import FinalCta from './finalCta';

/**
 * Landing page composition. Section order follows the conversion path:
 * value proposition → catalogue proof → offer → onboarding → reassurance →
 * compatibility → objections → final call to action.
 */
export default function LandingPage() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: SITE.url,
    logo: `${SITE.url}/logo.png`,
    description: SITE.description,
    email: CONTACT.email,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: `+${CONTACT.whatsappNumber}`,
      contactType: 'customer support',
      availableLanguage: ['French', 'English'],
    },
  };

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `Abonnement IPTV ${SITE.name}`,
    description: SITE.description,
    brand: { '@type': 'Brand', name: SITE.name },
    offers: ALL_PLANS.map((plan) => ({
      '@type': 'Offer',
      name: plan.name,
      price: plan.price,
      priceCurrency: 'EUR',
      url: plan.link,
      availability: 'https://schema.org/InStock',
    })),
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: allFaqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  };

  return (
    <>
      <Seo
        title="Abonnement IPTV France & Belgique — 79 000 chaînes en 4K"
        path="/"
      />
      <JsonLd data={organizationSchema} />
      <JsonLd data={productSchema} />
      <JsonLd data={faqSchema} />

      <Home />
      <Sports />
      <Pricing />
      <How />
      <Trust />
      <Devices />
      <FAQ />
      <FinalCta />
    </>
  );
}
